import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    components:{
        Header: ()=> import('@/components/header/index.vue'),
        leftBar: ()=> import('@/components/left-bar/index.vue'),
        TableOptions: ()=> import('@/components/table/options/index.vue'),
        Table: ()=> import('@/components/table/list/index.vue'),
    },
    data(){
       return{
           fields:[
               {
                   key:'id',
                   label:'№',
               },
               {
                   key:'register_number',
                   label:'Номер реєстру',
               },
               {
                   key:'register_count',
                   label:'Кіл-ть ЕН',
               },
               {
                   key:'register_created',
                   label:'Дата створення',
               },
               {
                   key:'register_dop',
                   label:'Додатково',
               },
               {
                   key:'register_ref',
                   label:'Ref',
               },
               {
                   key:'register_printed',
                   label:'Стан',
               },
               {
                   key:'register_print',
                   label:'Друк',
               },
           ],
           items:[],
           npCounterparties: [],
       }
    },
    computed:{
      ...mapGetters({
          registryList:'npRegistry/registryList',
          options:'config/options',
          npCounterpartiesList: 'npAutomation/npCounterparties',
      }),
      defaultApiKey() {
          // Use default counterparty's API key (backend will resolve via db_counterparty_id)
          // Since we can't access API key directly, we'll use db_counterparty_id approach
          const defaultCounterparty = this.npCounterparties.find(cp => cp.is_default === true);
          if (defaultCounterparty && defaultCounterparty.id) {
              // Return null to indicate we should use db_counterparty_id instead
              return null;
          }
          // No fallback - require default counterparty
          return null;
      },
      defaultCounterpartyId() {
          const defaultCounterparty = this.npCounterparties.find(cp => cp.is_default === true);
          return defaultCounterparty?.id || null;
      },
    },
    watch:{
        registryList(e){
            // Require default counterparty - no fallback to global API key
            if (!this.defaultCounterpartyId) {
                const errorMsg = 'Необхідно встановити контрагента за замовчуванням в налаштуваннях Нової Пошти';
                if (this.$toasted) {
                    this.$toasted.error(errorMsg, { duration: 5000 });
                }
                console.error('No default counterparty found in database for register printing');
                this.items = [];
                return;
            }
            
            this.items = [];
            let i = 0;
            e.models.map(item=>{
                i++
                this.items.push({
                    id:i,
                    register_number: item.Number,
                    register_count: item.Count,
                    register_created: item.DateTime,
                    register_dop: item.Description,
                    register_ref: item.Ref,
                    register_printed: item.Printed,
                    register_print: {
                        ref: item.Ref, 
                        key: null, // Not used when printing via backend
                        db_counterparty_id: this.defaultCounterpartyId // Backend will use this to get counterparty's API key
                    }
                })
            });
        },
        npCounterpartiesList(data) {
            if (data && Array.isArray(data)) {
                this.npCounterparties = data;
            }
        },
    },
    created() {
        this.toggleLoadingStatus(true);
        // Load counterparties first to get default counterparty
        this.getNpCounterparties().then(() => {
            this.getOptions().then(()=>{
                if (!this.defaultCounterpartyId) {
                    this.toggleLoadingStatus(false);
                    const errorMsg = 'Необхідно встановити контрагента за замовчуванням в налаштуваннях Нової Пошти';
                    this.$toasted?.error(errorMsg, { duration: 5000 });
                    return;
                }
                this.getRegistryList({ db_counterparty_id: this.defaultCounterpartyId }).then(()=>{
                    this.toggleLoadingStatus(false);
                })
            });
        }).catch(() => {
            // If counterparties fail to load, show error
            this.toggleLoadingStatus(false);
            const errorMsg = 'Помилка завантаження контрагентів. Перевірте налаштування Нової Пошти.';
            if (this.$toasted) {
                this.$toasted.error(errorMsg, { duration: 5000 });
            }
            console.error('Failed to load counterparties for registers');
        });
    },
    methods:{
        editClickItem(){
        },
        removeItem(){
        },
        ...mapActions({
            getRegistryList:'npRegistry/getRegistryList',
            getOptions:'config/getOptions',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        }),
    }
}
